module.exports = __webpack_public_path__ + "img/pick2.a792898e.png";